import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PropertyFeedSkeleton: React.FC = () => (
    <div className="tw-py-3 tw-px-3 bg-white rounded-lg shadow-md tw-border-b-[1px] tw-border-gray-400 tw-mx-auto tw-w-full md:tw-max-w-[600px]">
        {/* Header Section */}
        <div>
            <div className="tw-cursor-pointer">
                <Skeleton width="40%" height="2rem" style={{ marginBottom: "0.5rem" }} />
                <Skeleton width="60%" height="1.25rem" style={{ marginBottom: "0.5rem" }} />
            </div>

            {/* Image Slider Section */}
            <div className="tw-relative">
                <Skeleton width="100%" height="14rem" borderRadius={8} />
            </div>
        </div>
        {/* Reactions Row */}
        <div className="tw-flex tw-justify-left tw-mt-3">
            <div className="tw-flex tw-gap-2">
                <Skeleton width="1.5rem" height="1.5rem" circle={true} />
            </div>
        </div>
        {/* Action Buttons */}
        <div className="tw-flex tw-gap-2 tw-mt-2">
            <span className="tw-w-[48%]">
                <Skeleton width="100%" height="2rem" borderRadius={20} />
            </span>
            <span className="tw-w-[48%]">
                <Skeleton width="100%" height="2rem" borderRadius={20} />
            </span>
        </div>
    </div>
);

export default PropertyFeedSkeleton;
